import React, { useState, useEffect } from 'react';
import { withTheme } from 'styled-components';
import { localize } from 'core/localization';
import ImagePlaceholder from 'assets/figures/ImagePlaceholder';
import LinkCurationContentParser from './LinkCurationContentParser';
import {
  LinkCurationContainer,
  LinkContentWrapper,
  LinkImage,
  ImageWrapper,
  ImageContainer,
  CustomDescription,
  Title,
  TextWrapper,
  Text,
  StaticLink,
  LinkIcon,
  StaticLinkWrapper
} from './LinkCuration.styled';

type LinkCurationProps = {
  content: string;
  theme: { [key: string]: any };
};

export const LinkCuration = ({ content }: LinkCurationProps) => {
  const [data] = useState(LinkCurationContentParser(content));
  const [showDefaultImagePlaceholder, setShowDefaultImagePlaceholder] = useState(false);
  const { title, text, imgUrl, imageAlt, imgClasses, resourceUrl, customDescription, type } = data;
  let descriptionNode: any = React.createRef();

  useEffect(() => {
    descriptionNode.current && descriptionNode.current.appendChild(customDescription);
  }, [descriptionNode, customDescription]);

  return (
    <LinkCurationContainer>
      {customDescription && <CustomDescription ref={descriptionNode}></CustomDescription>}
      <LinkContentWrapper href={resourceUrl} target="_blank" type={type} tabIndex={1}>
        {type !== 'curation-without-image' && (
          <ImageContainer>
            <ImageWrapper className={imgClasses}>
              {!showDefaultImagePlaceholder && (
                <LinkImage
                  src={imgUrl}
                  alt={imageAlt}
                  onError={() => setShowDefaultImagePlaceholder(true)}
                />
              )}
              {showDefaultImagePlaceholder && <ImagePlaceholder alt={title} />}
            </ImageWrapper>
          </ImageContainer>
        )}
        <TextWrapper>
          <Title title={title}>{title}</Title>
          <Text title={text}>{text}</Text>
          <StaticLinkWrapper title={resourceUrl}>
            <LinkIcon size={12} name="link" />
            <StaticLink>{localize('[visit the page]')}</StaticLink>
          </StaticLinkWrapper>
        </TextWrapper>
      </LinkContentWrapper>
    </LinkCurationContainer>
  );
};

export default withTheme(LinkCuration);
